/**
 * Team Inbox — email send seam (impure; lazy-imports firebase like
 * lib/messagesStore + adminApi so every pure module above stays SDK-free).
 *
 * Reply path (spec §3.4): the existing `sendEmailToClient` callable, extended
 * by Part 1 to accept a no-project send — explicit `to` + `from` + `inReplyTo`
 * for a triage item that is not yet a project. We send from care@aayatanveda.in
 * so the client's reply threads back into this same public inbox (AD-014).
 */
import { CARE_EMAIL, type EmailReplyParams } from './emailStore';

async function callable<TReq, TRes>(name: string, data: TReq): Promise<TRes> {
  const [{ functions }, { httpsCallable }] = await Promise.all([
    import('../../../lib/firebase'),
    import('firebase/functions'),
  ]);
  const fn = httpsCallable<TReq, TRes>(functions, name);
  const res = await fn(data);
  return res.data;
}

export interface EmailSendResult {
  ok: boolean;
  messageId?: string | null;
}

/** Send a reply to a care@ triage email (no project). Throws on failure. */
export function sendEmailReply(
  params: EmailReplyParams,
): Promise<EmailSendResult> {
  return callable<EmailReplyParams, EmailSendResult>(
    'sendEmailToClient',
    params,
  );
}

/** Start a fresh outbound email from care@ (Compose — NEW-LIVE). */
export function sendNewEmail(params: {
  to: string;
  subject: string;
  body: string;
}): Promise<EmailSendResult> {
  return callable<EmailReplyParams, EmailSendResult>('sendEmailToClient', {
    to: params.to,
    from: CARE_EMAIL,
    subject: params.subject,
    inReplyTo: '',
    body: params.body,
  });
}
